<template>
  <div>
    <h1>Signing in...</h1>
  </div>
</template>

<script>
import { authService } from '@/js/authentication/authentication'

export default {
  async mounted() {
    const queryReturnUrl = this.$route.query.returnUrl
    try {
      const callbackState = await authService.handleCallback()
      await this.$store.dispatch('authentication/updateLoggedInStatus')

      const resolvedReturnUrl = callbackState || queryReturnUrl || '/'

      this.$router.replace(resolvedReturnUrl)
    } catch (error) {
      const message = error?.message || ''
      if (message.includes('No matching state found') || message.includes('No state in response')) {
        // Handle stale/missing state from duplicate callbacks or interrupted auth redirects.
        console.warn('OIDC callback state issue detected — clearing and redirecting home')
        await authService.clearStaleState()
      } else {
        console.error('Authentication callback error:', error)
      }
      this.$router.replace('/')
    }
  },
}
</script>

